export default {"src":"https://cdn.seaya.az/dist//_next/static/media/agalarov.5eac6b4b.svg","height":41,"width":189,"blurWidth":0,"blurHeight":0};